import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopNav } from './TopNav';

export const AppLayout = () => {
  return (
    <div className="flex h-screen w-full bg-blueprint text-slate-200 overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col h-full overflow-hidden relative">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-950/80 pointer-events-none z-0"></div>
        <TopNav />
        <main className="flex-1 overflow-x-hidden overflow-y-auto p-4 md:p-8 z-10 scroll-smooth">
          <Outlet />
        </main>
        <footer className="py-3 px-8 border-t border-slate-800/50 flex justify-between items-center z-10 bg-slate-950/50 backdrop-blur-sm">
          <div className="flex gap-4">
            <span className="text-[9px] text-slate-600 uppercase font-mono tracking-tighter">System: v2.4.0-Stable</span>
            <span className="text-[9px] text-slate-600 uppercase font-mono tracking-tighter">Encryption: AES-256</span>
          </div>
          <p className="text-[10px] text-slate-500 font-mono tracking-[0.2em] uppercase">
            Made by <span className="text-slate-400">LingLink AI</span> and <span className="text-slate-400">DigLab AI</span>
          </p>
        </footer>
      </div>
    </div>
  );
};